var map = {
	"./404.svg": 1019,
	"./bug.svg": 1020,
	"./chart.svg": 1021,
	"./clipboard.svg": 1022,
	"./component.svg": 1023,
	"./dashboard.svg": 1024,
	"./documentation.svg": 1025,
	"./download.svg": 1026,
	"./drag.svg": 1027,
	"./edit.svg": 1028,
	"./education.svg": 1029,
	"./email.svg": 1030,
	"./example.svg": 1031,
	"./excel.svg": 1032,
	"./exit-fullscreen.svg": 1033,
	"./eye-open.svg": 1034,
	"./eye.svg": 1035,
	"./form.svg": 1036,
	"./fullscreen.svg": 1037,
	"./guide.svg": 1038,
	"./icon.svg": 1039,
	"./international.svg": 1040,
	"./language.svg": 1041,
	"./link.svg": 1042,
	"./list.svg": 1043,
	"./lock.svg": 1044,
	"./love.svg": 1045,
	"./message.svg": 1046,
	"./money.svg": 1047,
	"./nested.svg": 1048,
	"./num.svg": 1049,
	"./password.svg": 1050,
	"./pdf.svg": 1051,
	"./people.svg": 1052,
	"./peoples.svg": 1053,
	"./qq.svg": 1054,
	"./search.svg": 1055,
	"./shopping.svg": 1056,
	"./size.svg": 1057,
	"./skill.svg": 1058,
	"./star.svg": 1059,
	"./tab.svg": 1060,
	"./table.svg": 1061,
	"./theme.svg": 1062,
	"./tree-table.svg": 1063,
	"./tree.svg": 1064,
	"./user.svg": 1065,
	"./video.svg": 1066,
	"./wechat.svg": 1067,
	"./zanting.svg": 1068,
	"./zip.svg": 1069
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1153;


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 1153
// module chunks = 36